import { render } from "./UiComponentsPage.vue?vue&type=template&id=010ab5a8&ts=true"
import script from "./UiComponentsPage.vue?vue&type=script&lang=ts"
export * from "./UiComponentsPage.vue?vue&type=script&lang=ts"

import "./UiComponentsPage.vue?vue&type=style&index=0&id=010ab5a8&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__